import { useEffect } from "react";
import { useOrganization } from "../context/OrganizationContext";
import { resolveOrgPolicies } from "../helpers/permissions";

/**
 * Sync OrganizationContext settings into App-level orgPolicies.
 * Mode Select / screen routing live outside PermissionProvider consumers
 * for some handlers; they must use the actor org's settings, not a
 * Nexora hardcode or empty actor.org_settings.
 */
export function OrgPoliciesSync({ onChange }) {
  const { settings } = useOrganization();

  useEffect(() => {
    if (typeof onChange !== "function") {
      return;
    }
    onChange(resolveOrgPolicies(settings));
  }, [settings, onChange]);

  return null;
}
